export default __webpack_public_path__ + "static/media/step1-2.c303a8de.png";